import { toRaw } from 'vue';
import { isNil } from 'lodash';
import { makeCompanySettings, type ISettings, type Maybe } from '@nova/core';

import type { CarrierCompany } from '@/modules/company/types';

export type CompanyWithOptionalSettings = Maybe<Pick<CarrierCompany, 'settings'>>;

/**
 * Unwrap Vue reactive Proxies before company objects reach @nova/core.
 * Core uses structuredClone on settings; Proxies throw DataCloneError.
 */
export function toPlainCompany(company: CompanyWithOptionalSettings): CompanyWithOptionalSettings {
  if (isNil(company)) {
    return null;
  }
  const rawCompany = toRaw(company);
  const settings = rawCompany.settings;
  return {
    ...rawCompany,
    settings: isNil(settings) ? settings : { ...toRaw(settings) }
  };
}

/**
 * Luna carrier company date/time display preferences.
 *
 * Source: `company.settings` on payloads loaded via auth/me, appointment user joins,
 * and company detail fetches. When the API returns null or a partial object, missing keys
 * default to MDY (date) and twelveHour (time) per EntitySettings.Company.
 */
export function resolveCompanyDisplaySettings(company: CompanyWithOptionalSettings): ISettings {
  return makeCompanySettings(toPlainCompany(company));
}
